export default {"src":"/_next/static/media/bazaar.3ee4acd7.svg","height":53,"width":176};